<!--
  The Early Access ribbon: the diagonal band across the page's top-left
  corner (its drawing is lib/earlyAccess.ts, its look
  styles/early-access.css). It is a button when it has something to do
  (`onactivate`), a link when it has somewhere to go (`href`), and
  otherwise a label that says "Early Access" and takes no pointer. Only
  the band itself is its hit area: the corner square around it lets every
  click through to what is under it.
-->
<script lang="ts">
  import { RIBBON_ACTION_LABEL, RIBBON_LABEL, ribbonArt } from '../earlyAccess';

  interface Props {
    /** The smaller size whatever the window's width: for a small surface (the extension's popup). */
    compact?: boolean;
    /** Send feedback from here. */
    onactivate?: () => void;
    /** Where feedback goes from here, when the page has no way to send it itself. */
    href?: string;
    /** Open `href` in a new tab (a web page; a `mailto:` address hands off to the mail client instead). */
    newTab?: boolean;
  }
  let { compact = false, onactivate, href, newTab = false }: Props = $props();

  const art = ribbonArt();
</script>

{#if onactivate}
  <button type="button" class="early-access" class:compact aria-label={RIBBON_ACTION_LABEL} title="Send feedback about Changeling" onclick={onactivate}
    >{@html art}</button
  >
{:else if href}
  <a class="early-access" class:compact {href} target={newTab ? '_blank' : undefined} rel={newTab ? 'noreferrer' : undefined} aria-label={RIBBON_ACTION_LABEL} data-external
    >{@html art}</a
  >
{:else}
  <span class="early-access" class:compact role="img" aria-label={RIBBON_LABEL}>{@html art}</span>
{/if}
